import AddedSportsModifier from './AddedSportsModifier';
import AddedLeaguesModifier from './AddedLeaguesModifier';
import AddedMatchesModifier from './AddedMatchesModifier';
import AddedMatchHighlightsModifier from './AddedMatchHighlightsModifier';
import AddedScoresModifier from './AddedScoresModifier';
import AddedOutcomesModifier from './AddedOutcomesModifier';
import AddedRatesModifier from './AddedRatesModifier';
import ChangedSportsModifier from './ChangedSportsModifier';
import ChangedLeaguesModifier from './ChangedLeaguesModifier';
import ChangedMatchesModifier from './ChangedMatchesModifier';
import ChangedScoresModifier from './ChangedScoresModifier';
import RemovedSportsModifier from './RemovedSportsModifier';
import RemovedLeaguesModifier from './RemovedLeaguesModifier';
import RemovedMatchesModifier from './RemovedMatchesModifier';
import RemovedScoresModifier from './RemovedScoresModifier';
import RemovedOutcomesModifier from './RemovedOutcomesModifier';
var ExpandKeyModifier = /** @class */ (function () {
    function ExpandKeyModifier(repository, modifiers) {
        this._modifiers = modifiers || [
            new AddedSportsModifier(repository),
            new AddedLeaguesModifier(repository),
            new AddedMatchesModifier(repository),
            new AddedMatchHighlightsModifier(repository),
            new AddedScoresModifier(repository),
            new AddedOutcomesModifier(repository),
            new AddedRatesModifier(repository),
            new ChangedSportsModifier(repository),
            new ChangedLeaguesModifier(repository),
            new ChangedMatchesModifier(repository),
            new ChangedScoresModifier(repository),
            new RemovedOutcomesModifier(repository),
            new RemovedScoresModifier(repository),
            new RemovedMatchesModifier(repository),
            new RemovedLeaguesModifier(repository),
            new RemovedSportsModifier(repository)
        ];
    }
    ExpandKeyModifier.prototype.modify = function (content) {
        for (var i = 0; i < this._modifiers.length; i++) {
            var modifier = this._modifiers[i];
            modifier.modify(content);
        }
    };
    return ExpandKeyModifier;
}());
export default ExpandKeyModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/ExpandKeyModifier.js